package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Task(
  public val id: String,
  public val parent_kind: String,
  public val parent_id: String?,
  public val status_id: String?,
  public val title: String,
  public val description: String?,
  public val status: String,
  public val priority: String?,
  public val effort: Long?,
  public val due_date: String?,
  public val estimated_minutes: Long?,
  public val real_minutes: Long?,
  public val recurrence: String?,
  public val pomodoro_pool_date: String?,
  public val order_index: Long,
  public val completed_at: Long?,
  public val kind: String?,
  public val deliverable: String?,
  public val acceptance: String?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
